import { useEffect } from 'react';
type SeoHeadProps = {
  title: string;
  description: string;
  /** JSON-LD structured data objects rendered for search engines and AI answer engines. */
  structuredData?: Record<string, unknown>[];
};
function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function SeoHead({
  title,
  description,
  structuredData
}: SeoHeadProps) {
  useEffect(() => {
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
  }, [title, description]);
  useEffect(() => {
    if (!structuredData?.length) return;
    const nodes = structuredData.map(data => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
      return script;
    });
    return () => {
      nodes.forEach(node => node.remove());
    };
  }, [structuredData]);
  return null;
}